import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { enUS, ru } from 'date-fns/locale';

export const formatDate = (date: any, formatType: any, locale: any = 'en') =>
  format(parseISO(date), formatType, {
    locale: locale === 'ru' ? ru : enUS,
  });
